module.exports = __webpack_public_path__ + "img/downloading.383aa104.svg";